import {
  makeStyles,
  tokens,
  Button,
  Card,
  CardHeader,
  Text,
  Title1,
} from '@fluentui/react-components';
import { VehicleCarParkingRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
    padding: tokens.spacingHorizontalM,
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    padding: tokens.spacingHorizontalXXL,
    textAlign: 'center',
    '@media (max-width: 599px)': {
      padding: tokens.spacingHorizontalL,
    },
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalM,
    marginBottom: tokens.spacingVerticalXL,
    '@media (max-width: 599px)': {
      marginBottom: tokens.spacingVerticalL,
    },
  },
  icon: {
    fontSize: '64px',
    color: tokens.colorBrandForeground1,
    '@media (max-width: 599px)': {
      fontSize: '48px',
    },
  },
  title: {
    fontFamily: "'Jost', 'Segoe UI', sans-serif",
    '@media (max-width: 599px)': {
      fontSize: tokens.fontSizeBase500,
    },
  },
  description: {
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalXL,
    '@media (max-width: 599px)': {
      marginBottom: tokens.spacingVerticalL,
      fontSize: tokens.fontSizeBase300,
    },
  },
  button: {
    width: '100%',
    minHeight: '44px', // Touch-friendly
  },
});

export default function LoginPage() {
  const styles = useStyles();
  const { t } = useTranslation();
  const { login } = useAuth();

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.logo}>
          <VehicleCarParkingRegular className={styles.icon} />
          <Title1 className={styles.title}>{t('login.title')}</Title1>
        </div>
        <CardHeader
          header={
            <Text className={styles.description}>
              {t('login.description')}
            </Text>
          }
        />
        <Button
          className={styles.button}
          appearance="primary"
          size="large"
          onClick={login}
        >
          {t('login.button')}
        </Button>
      </Card>
    </div>
  );
}
